import { css } from 'styled-components';

const dark = css``;

const light = css``;

export default { dark, light };
